module.exports = __webpack_public_path__ + "img/VisibilityOutlined.3cbb9087.svg";